module.exports = __webpack_public_path__ + "static/media/uranus3.e0cffabc.png";